export default {
  URLS: {
    PERMISSION: '/t2b/access/permission/',
    SIDEMENU: '/t2b/access/sidemenu/',
  },
};
